// extracted by mini-css-extract-plugin
module.exports = {"BlueButton":"BlueButton_BlueButton__28UPk"};